module.exports = __webpack_public_path__ + "img/mob_menu_icon.c7e7dfba.svg";